module.exports = __webpack_public_path__ + "static/media/investor.38ecc714.png";